<div class="inner-page-section">
    <div class="sub-section-header">
        <h1 class="title">Task Options</h1>
        <span class="actions">
            Last Updated: <span *ngIf="lastUpdated; else never">{{ lastUpdated | date: 'M/d/yy, h:mm a' }}</span>
            <ng-template #never>Never</ng-template>
        </span>
    </div>

    <mat-card appearance="outlined" style="margin-bottom: 25px;">
        <mat-card-content style="display: flex; flex-direction: column; gap: 16px;">
            <div *ngFor="let item of toggleSettings" style="display: flex; flex-direction: column; gap: 8px;">
                <mat-slide-toggle [checked]="item.currentValue" (change)="onToggleFeature(item, $event.checked)">
                    {{ item.title }}
                </mat-slide-toggle>
                <span>{{ item.description }}</span>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card-content *ngIf="errorMessage">
        {{ errorMessage }}
    </mat-card-content>
</div>
